<script setup lang="ts">
const props = defineProps({
  home: null,
  archive: null,
  sharedFolderId: null
})
const { isSelectedIn } = useSelection()
const { fileIdAttr } = useGlobals()
const { state: gestureState } = useGestures()

const hoverable = computed(() => gestureState.value.gesture !== "drag-file")
const sidebarSelection = computed(() => isSelectedIn(props.home.fileId, "sidebar"))
const collectionSelection = computed(() => isSelectedIn(props.home.fileId, "collection-view"))
const dragOver = computed(() => gestureState.value.sidebarSharedFoldersFileDraggedOver?.fileId === props.home.fileId)
</script>

<template>
  <div
    :[dataAttr(fileIdAttr)]="home.fileId"
    class="entry-shared-folder"
    :class="{ sidebarSelection, collectionSelection, dragOver, hoverable }"
  >
    <file-item class="file-inner" :file="home" />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.entry-shared-folder
  @apply text-[#{$sidebar-t-item}] t-sidebar-item -m-1.5 p-1.5 rounded-[#{$sidebar-br-item-hovered}] cursor-pointer
  &.hoverable:hover, &.dragOver
    @apply bg-[#{$sidebar-bg-item-hovered}]

.file-inner
  @apply gap-[#{$sidebar-gap-item-icon}]

.sidebarSelection
  @apply bg-$global-blue-primary
  &:hover
    @apply bg-$global-blue-primary
.collectionSelection
  @apply bg-$global-blue-accent
  &:hover
    @apply bg-$global-blue-accent
</style>
